import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Container } from "react-bootstrap";
import { CloseSquare } from "iconsax-react";

import { SimsCategoryHomePageData } from "../../utility/content/homePage/SimsCategoryHomePage";

import productType from "../../redux/actions/product/productType";
import gradeType from "../../redux/actions/grade/gradeType";
import subjectType from "../../redux/actions/subject/subjectType";
import hashtagType from "../../redux/actions/hashtag/hashtagType";

import useFilter from "../../hooks/useFilter";
import { calculatePageSize } from "../../libs/pagingDetail";

import { CategoryRowComponent } from "../../components/public/home/category";
import SimsFilterComponent from "../../components/public/simsFilter";
import { Option } from "../../components/public/simsFilter";

import PaginationComponent from "../../components/public/pagination";

import {
  StyledHeroSec,
  StyledSimsSec,
  HashtagFilterWrapper,
  HashtagLabel,
  HashtagLabelSkeleton,
  HashtagFilterContainer,
  SelectFilterRow,
} from "./styledSimPage";

import filterDuplicateItems from "../../libs/filterDuplicateItems";
import Sims from "../../components/public/sims";

const SimPageContainer = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userDetail);
  const productDetail = useSelector((state) => state.productDetail);
  const gradeDetail = useSelector((state) => state.gradeDetail);
  const subjectDetail = useSelector((state) => state.subjectDetail);
  const hashtagDetail = useSelector((state) => state.hashtagDetail);
  const location = useLocation();
  const search = location.search;
  const filtersRowRef = useRef(null);
  const { onChange, onFilterChange, selectFilters, setSelectFilter, filterState } =
    useFilter({
      grade: [],
      subject: [],
      sorting: [],
      hashtag: [],
    });

  useEffect(() => {
    dispatch({
      type: productType.START_FETCHING_PRODUCT,
      search: search
        ? `${search}&page_size=${process.env.REACT_APP_PAGE_SIZE}&page=${
            filterState["page"] || 1
          }`
        : `?page_size=${process.env.REACT_APP_PAGE_SIZE}&page=${
            filterState["page"] || 1
          }`,
    });
  }, [search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("view-port") || window.location == window.parent.location) {
      dispatch({ type: gradeType.START_FETCHING_GRADE });
      dispatch({ type: subjectType.START_FETCHING_SUBJECT });
      dispatch({ type: hashtagType.START_FETCHING_HASHTAG });
    }
  }, []);

  const sortByProperty = (property) => {
    // Order Acending
    return function (a, b) {
      if (a[property] > b[property]) return 1;
      if (a[property] < b[property]) return -1;
      return 0;
    };
  };

  const gradeOptions = () => {
    const allGrades = gradeDetail.grade.results
      ? gradeDetail.grade.results.sort(sortByProperty("id"))
      : [];
    let gradeOpt = [];
    for (const parent of allGrades) {
      const calcParentValue = parent.grade.map((grade) => grade.level).join();
      gradeOpt.push({
        label: parent.name,
        value: calcParentValue,
        childrenValue: parent.grade.map((grade) => grade.level),
        type: "optgroup",
        child: parent.grade.reduce((output, item, index) => {
          output.push({
            label: item.name,
            value: item.level,
            parentValue: calcParentValue,
          });
          return output;
        }, []),
      });
      for (const grade of parent.grade.sort(sortByProperty("level"))) {
        if (grade.level === 13) continue; // Skip university option
        gradeOpt.push({
          label: grade.name,
          value: grade.level,
          type: "grade",
          parentValue: calcParentValue,
        });
      }
    }
    return gradeOpt;
  };
  const subjectOptions = () => {
    const subjects = subjectDetail.subject.results
      ? subjectDetail.subject.results
      : [];
    return subjects.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    });
  };
  let sortingOptions = [
    { label: "🆕 جدیدترین‌ها", value: "recent" },
    { label: "⭐ پرامتیازترین‌ها", value: "top_score" },
    { label: "🔠 حروف الفبا", value: "alphabet" },
    { label: "❤️ محبوب‌ترین‌ها", value: "most_popular" },
  ];
  if (user.isLogin) {
    sortingOptions = [
      { label: "🔬 آزمایش‌های من", value: "default" },
      ...sortingOptions,
    ];
  } else {
    sortingOptions = [{ label: "❇️ پیش‌فرض", value: "default" }, ...sortingOptions];
  }

  const hashtagOptions =
    !hashtagDetail.loading && hashtagDetail.hashtag?.length
      ? hashtagDetail.hashtag
      : [];

  // Set select box options from URL params
  const isGradeOptions = Boolean(gradeOptions()?.length);
  const isSubjectOptions = Boolean(subjectOptions()?.length);
  const isHashtagFromURL = Boolean(Object.values(filterState["filter_hashtag__id__in"] != null ? filterState["filter_hashtag__id__in"] : {})[0] != '' && Object.values(filterState["filter_hashtag__id__in"] != null ? filterState["filter_hashtag__id__in"] : {})[0] != undefined);
  const isHashtagLoaded = Boolean(hashtagDetail?.hashtag?.length);

  useEffect(() => {
    if (isHashtagLoaded && search.includes("hashtag")) {
      const currentHashtagIDFromURL = Object.values(
        filterState["filter_hashtag__id__in"] != null ? filterState["filter_hashtag__id__in"] : {}
      ).map((hashtagID) => Number(hashtagID));
      const hashtagFromURL = hashtagOptions.filter(
        (hashtag) =>
          hashtag.id ===
          currentHashtagIDFromURL.find(
            (currentHashtag) => currentHashtag === hashtag.id
          )
      );
      setSelectFilter((prevSelectFilters) => {
        return {
          ...prevSelectFilters,
          hashtag: hashtagFromURL,
        };
      });
    }
    if (isGradeOptions && search.includes("grade")) {
      const currntGradesLevelFromURL = Object.values(
        filterState["filter_grade__level__in"] != null ? filterState["filter_grade__level__in"] : {}
      ).map((level) => Number(level));
      const gradesFromURL = gradeOptions().filter(
        (grade) =>
          grade.value ===
          currntGradesLevelFromURL.find(
            (currentGrade) => currentGrade === grade.value
          )
      );
      setSelectFilter((prevSelectFilters) => {
        return {
          ...prevSelectFilters,
          grade: filterDuplicateItems([...selectFilters.grade, ...gradesFromURL]),
        };
      });
    }
    if (isSubjectOptions && search.includes("subject")) {
      const currentSubjectIDFromURL = Object.values(
        filterState["filter_subject__id__in"] != null ? filterState["filter_subject__id__in"] : {}
      ).map((id) => Number(id));
      const subjectsFromURL = subjectOptions().filter(
        (subject) =>
          subject.value ===
          currentSubjectIDFromURL.find(
            (currentSubject) => currentSubject === subject.value
          )
      );
      setSelectFilter((prevSelectFilters) => {
        return {
          ...prevSelectFilters,
          subject: subjectsFromURL,
        };
      });
    }
    if (search.includes("sort_by")) {
      const currentSortingValueFromURL = filterState["sort_by"];
      const sortingFromURL = sortingOptions.filter(
        (sorting) => sorting.value === currentSortingValueFromURL
      );
      setSelectFilter((prevSelectFilters) => {
        return {
          ...prevSelectFilters,
          sorting: sortingFromURL,
        };
      });
    }
  }, [isGradeOptions, isSubjectOptions, isHashtagLoaded, search]);

  const handleDeleteHashtag = (deletedHashtagID) => {
    const newHashtagState = selectFilters.hashtag.filter(
      (item) => item.id !== deletedHashtagID
    );
    setSelectFilter((prevSelectFilters) => {
      return {
        ...prevSelectFilters,
        hashtag: newHashtagState,
      };
    });

    onChange("filter_hashtag__id__in", newHashtagState);
  };

  return (
    <>
      <StyledHeroSec>
        <Container>
          <CategoryRowComponent
            categories={SimsCategoryHomePageData}
            refProp={filtersRowRef}
          />
        </Container>
      </StyledHeroSec>
      <StyledSimsSec ref={filtersRowRef}>
        <Container>
          <h3 className="text-center mb-5">
            با انتخاب فیلترهای زیر می‌توانید آزمایش مورد نظرتان را جستجو کنید.
          </h3>
          <SelectFilterRow>
            <SimsFilterComponent
              name="grade"
              options={gradeOptions()}
              isSearchable={true}
              placeholder={"پایه تحصیلی خود را انتخاب کنید."}
              isMulti={true}
              value={selectFilters.grade?.length ? selectFilters.grade : null}
              onChange={(selectedOptions, actionMeta) => {
                onFilterChange(
                  selectFilters.grade,
                  "filter_grade__level__in",
                  actionMeta
                );
              }}
              components={{ Option }}
            />
            <SimsFilterComponent
              name="subject"
              options={subjectOptions()}
              isSearchable={true}
              placeholder={"درس مورد نظر را انتخاب کنید."}
              isMulti={true}
              value={selectFilters.subject.length ? selectFilters.subject : null}
              components={{ Option }}
              onChange={(selectedOptions, actionMeta) => {
                onFilterChange(
                  selectFilters.subject,
                  "filter_subject__id__in",
                  actionMeta
                );
              }}
            />
            <SimsFilterComponent
              name="sorting"
              options={sortingOptions}
              isSearchable={false}
              placeholder={"مرتب‌سازی آزمایش‌ها براساس"}
              isSelect={true}
              onChange={(selectedOption, actionMeta) => {
                onFilterChange(
                  selectFilters.sorting,
                  "sort_by",
                  actionMeta,
                  selectedOption
                );
              }}
              isMulti={false}
              value={selectFilters?.sorting ? selectFilters?.sorting[0] : null}
            />
          </SelectFilterRow>
          {isHashtagFromURL && (
            <HashtagFilterContainer className="text-center mt-5">
              <p className="mb-4">جست و جو براساس برچسب</p>
              {!selectFilters.hashtag.length ? (
                <HashtagLabelSkeleton
                  variant="rectangular"
                  width={110}
                  height={45}
                  className="mx-auto"
                />
              ) : (
                <HashtagFilterWrapper>
                  {selectFilters.hashtag.map((hashtag) => (
                    <HashtagLabel key={hashtag.id} className="mb-2">
                      <span>{hashtag.name}</span>
                      <CloseSquare
                        className="close-mark"
                        onClick={() => handleDeleteHashtag(hashtag.id)}
                      />
                    </HashtagLabel>
                  ))}
                </HashtagFilterWrapper>
              )}
            </HashtagFilterContainer>
          )}
          <Sims simsData={productDetail} showFilters />
          {productDetail.product && (
            <PaginationComponent
              pageNumber={calculatePageSize(
                productDetail.product.count,
                filterState["page_size"]
              )}
              currentPage={filterState["page"] || 1}
              handleChangePage={(e, value) => {
                onChange("page", value);
              }}
              className="mt-5"
              defaulPage={1}
            />
          )}
        </Container>
      </StyledSimsSec>
    </>
  );
};

export default SimPageContainer;
